import * as React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { setToolbar } from '../store/toolbar'
import { setBreadcrumbs } from '../store/breadcrumbs'

import { AgGridReact } from 'ag-grid-react'

import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'

import { LabNameRenderer as LabRenderer } from '../components/aggrid/LabRenderer'

import Tooltip from '@mui/material/Tooltip'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Autocomplete from "@mui/material/Autocomplete";

import HomeIcon from '@mui/icons-material/HomeRounded'
import AdminIcon from '@mui/icons-material/AdminPanelSettingsRounded'
import UsersIcon from '@mui/icons-material/Group'
import AddUserIcon from '@mui/icons-material/PersonAdd'
import RemoveUserIcon from '@mui/icons-material/PersonOff'
import EditIcon from '@mui/icons-material/Edit'

import CheckIcon from '@mui/icons-material/Check'

import TextField from '@mui/material/TextField'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl';

import Dialog, { DialogProps } from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'

import DialogTitle from '../components/DialogTitle'

import { Icon as IconifyIcon, InlineIcon as IconifyIconInline } from "@iconify/react"

import VerticalSeparator from '../components/VerticalSeparator'

import BooleanCellRenderer from '../components/aggrid/BooleanCellRenderer'


import API from '../api/fetchAPI'

import './UserManagement.scss'
import templatesPromise from "../util/mail/base/Templates";


const ActionsCellRenderer = (props) => {
    const user = {
        id: props.value._id,
        username: props.value.username,
        email: props.value.email
    }
    return (
        <>
            <Tooltip title="Edit User" placement="top">
                <IconButton className="action-button" aria-label="edit" size="small" onClick={() => props.context.openEditUserDialog(user)} >
                    <EditIcon fontSize="small" />
                </IconButton>
            </Tooltip>
            <Tooltip title="Reset Activation" placement="top">
                <IconButton className="action-button" aria-label="refresh" size="small" onClick={() => props.context.openResetActivationDialog(user)} >
                    <IconifyIcon icon="material-symbols:restart-alt-rounded"/>
                </IconButton>
            </Tooltip>
            { props.value.state.id !== 'CREATED' && props.value.state.id !== 'ACTIVATION_PENDING' && props.value.state.id !== 'ACTIVATION_RESET_PENDING'? 
                <Tooltip title="Reset Password" placement="top">
                    <IconButton className="action-button" aria-label="refresh" size="small" onClick={() => props.context.openResetPasswordDialog(user)} >
                        <IconifyIcon icon="material-symbols:lock-reset-rounded"/>
                    </IconButton>
                </Tooltip>
            : null }
            <Tooltip title="Delete User" placement="top">
                <IconButton className="action-button" aria-label="refresh" size="small" onClick={() => props.context.openDeleteUserDialog(user)} >
                   <IconifyIcon icon="material-symbols:person-off"/>
                </IconButton>
            </Tooltip>
        </>
    )
}



const StateRenderer = (props) => {
    const color = props.value.id == 'ACTIVE' ? 'darkgreen' : '#AAA'
    return (
        <span style={{fontWeight: 'bold', color: color}}>
            {props.value.id}
        </span>
    )
}





function AddUserForm({usernames,emails,labs,onSuccess}) {

    const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    const [username, setUsername] = React.useState(null)
    const [email, setEmail] = React.useState(null)
    const [lab, setLab] = React.useState('')
    const [sendActivationLink, setSendActivationLink] = React.useState(false)

    const [errorMessage, setErrorMessage] = React.useState(null)
    const [successMessage, setSuccessMessage] = React.useState(null)
    const [templates, setTemplates] = React.useState(null)

    React.useEffect(() => {

        // Load templates asynchronously
        templatesPromise.then(loadedTemplates => {
            setTemplates(loadedTemplates)
        }).catch(error => {
            console.error('Failed to load templates:', error)
        })
    }, [])

    const handleUsernameChange = (event) => setUsername(event.target.value)
    const handleEmailChange = (event) => setEmail(event.target.value)
    // const handleLabChange = (event) => setLab(event.target.value)
    const handleSendActivationLinkChange = (event) => setSendActivationLink(event.target.checked)

    const handleLabChange = (event) => {
        console.log("HANDLE LAB CHANGE")
        console.log(event.target.value)
        setLab(event.target.value)
    }

    const addUser = () => {
        // console.log(`username: ${username}`)
        // console.log(`email: ${email}`)
        // console.log(`send registry: ${sendRegistryLink}`)

        if(typeof username !== 'string' || username.trim().length == 0) {
            setErrorMessage('Username is required')
            return
        }

        if(typeof email !== 'string' || email.trim().length == 0) {
            setErrorMessage('Email is required')
            return
        }

        if(typeof lab !== 'string' || lab.trim().length == 0) {
            setErrorMessage('Lab is required')
            return
        }

        if(usernames.includes(username)) {
            setErrorMessage('Username already exists!')
            return
        }

        if(emails.includes(email)) {
            setErrorMessage('Email already exists!')
            return
        }

        const isEmail = EMAIL_REGEX.test(email)
        console.log(isEmail)
        if(!isEmail) {
            setErrorMessage('Wrong email syntax')
            return
        }

        setErrorMessage(null)

        API.post('/api/user/add-user-admin', {
            params: {
                username: username.trim(),
                email: email.trim(),
                lab: lab.trim(),
                sendActivationLink: sendActivationLink,
                template: templates['activation']
            }
        }).then( user => {
            setSuccessMessage('User created')
            setTimeout(onSuccess, 1000)
        })
    }

    return (
        <div className="add-user-form">
            <TextField
                // required
                id="username"
                label="Username"
                variant="filled"
                size="small"
                value={username}
                onChange={handleUsernameChange}
            />
            <TextField
                // required
                id="email"
                label="Email"
                variant="filled"
                size="small"
                value={email}
                onChange={handleEmailChange}
            />

            <Autocomplete
                options={labs}
                getOptionLabel={(option) => option.name}
                value={labs.find((l) => l._id === lab) || null}
                onChange={(event, newValue) => {
                setLab(newValue ? newValue._id : "");
                }}
                renderInput={(params) => (
                <TextField {...params} label="Lab" variant="filled" size="small" />
                )}
                isOptionEqualToValue={(option, value) => option._id === value._id}
            />

            <FormControlLabel
                control={
                    <Checkbox
                        checked={sendActivationLink}
                        onChange={handleSendActivationLinkChange}
                    />
                }
                label="Send activation email (optional)"
            />
            
            <div style={{fontSize: '12px', color: '#666', marginTop: '-10px', marginBottom: '10px'}}>
                If unchecked, users can self-activate via "First time user" link on login page
            </div>
            
            <Button
                style={{alignSelf: 'center'}}
                onClick={addUser}
            >
                Add User&nbsp;<AddUserIcon/>
            </Button>
            {errorMessage ? <div className="message error-message">{errorMessage}</div> : null}
            {successMessage ? <div className="message success-message">{successMessage}</div> : null}
        </div>
    )
}

function EditUserForm({user, users, labs, onSuccess}) {
    const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    const [username, setUsername] = React.useState(user?.username || '')
    const [email, setEmail] = React.useState(user?.email || '')
    const [firstname, setFirstname] = React.useState(user?.firstname || '')
    const [lastname, setLastname] = React.useState(user?.lastname || '')
    const [lab, setLab] = React.useState(user?.lab || '')
    const [role, setRole] = React.useState(user?.role || '')
    const [isSuperuser, setIsSuperuser] = React.useState(user?.isSuperuser || false)

    const [errorMessage, setErrorMessage] = React.useState(null)
    const [successMessage, setSuccessMessage] = React.useState(null)

    const handleUsernameChange = (event) => setUsername(event.target.value)
    const handleEmailChange = (event) => setEmail(event.target.value)
    const handleFirstnameChange = (event) => setFirstname(event.target.value)
    const handleLastnameChange = (event) => setLastname(event.target.value)
    const handleRoleChange = (event) => setRole(event.target.value)
    const handleIsSuperuserChange = (event) => setIsSuperuser(event.target.checked)

    const handleLabChange = (event) => {
        setLab(event.target.value)
    }

    const updateUser = () => {
        if(typeof username !== 'string' || username.trim().length === 0) {
            setErrorMessage('Username is required')
            return
        }

        if(typeof email !== 'string' || email.trim().length === 0) {
            setErrorMessage('Email is required')
            return
        }

        if(typeof lab !== 'string' || lab.trim().length === 0) {
            setErrorMessage('Lab is required')
            return
        }

        // Check for duplicate usernames (excluding current user)
        const otherUsers = users.filter(u => u._id !== user.id)
        if(otherUsers.some(u => u.username === username.trim())) {
            setErrorMessage('Username already exists!')
            return
        }

        if(otherUsers.some(u => u.email === email.trim())) {
            setErrorMessage('Email already exists!')
            return
        }

        const isEmail = EMAIL_REGEX.test(email)
        if(!isEmail) {
            setErrorMessage('Wrong email syntax')
            return
        }

        setErrorMessage(null)

        API.post('/api/user/update-user-admin', {
            params: {
                id: user.id,
                username: username.trim(),
                email: email.trim(),
                firstname: firstname.trim(),
                lastname: lastname.trim(),
                lab: lab.trim(),
                role: role.trim(),
                isSuperuser: isSuperuser
            }
        }).then(() => {
            setSuccessMessage('User updated')
            setTimeout(onSuccess, 1000)
        }).catch((error) => {
            console.error('Error updating user:', error)
            setErrorMessage(error.response?.data?.message || 'Error updating user')
        })
    }

    return (
        <div className="edit-user-form" style={{ display: 'flex', flexDirection: 'column', gap: '16px', minWidth: '400px' }}>
            <TextField
                id="username"
                label="Username"
                variant="filled"
                size="small"
                required
                value={username}
                onChange={handleUsernameChange}
            />
            <TextField
                id="email"
                label="Email"
                variant="filled"
                size="small"
                required
                value={email}
                onChange={handleEmailChange}
            />
            <TextField
                id="firstname"
                label="First Name"
                variant="filled"
                size="small"
                value={firstname}
                onChange={handleFirstnameChange}
            />
            <TextField
                id="lastname"
                label="Last Name"
                variant="filled"
                size="small"
                value={lastname}
                onChange={handleLastnameChange}
            />
            <TextField
                id="role"
                label="Role"
                variant="filled"
                size="small"
                value={role}
                onChange={handleRoleChange}
            />

            <Autocomplete
                options={labs}
                getOptionLabel={(option) => option.name}
                value={labs.find((l) => l._id === lab) || null}
                onChange={(event, newValue) => {
                    setLab(newValue ? newValue._id : "");
                }}
                renderInput={(params) => (
                    <TextField {...params} label="Lab" variant="filled" size="small" required />
                )}
                isOptionEqualToValue={(option, value) => option._id === value._id}
            />

            <FormControlLabel
                control={
                    <Checkbox
                        checked={isSuperuser}
                        onChange={handleIsSuperuserChange}
                    />
                }
                label="Is Superuser"
            />

            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', marginTop: '8px' }}>
                <Button onClick={updateUser} variant="contained">
                    Update User
                </Button>
                <Button onClick={() => onSuccess()} variant="outlined">
                    Cancel
                </Button>
            </div>
            {errorMessage ? <div className="message error-message">{errorMessage}</div> : null}
            {successMessage ? <div className="message success-message">{successMessage}</div> : null}
        </div>
    )
}










export default function UserManagement() {

    const dispatch = useDispatch()

    const gridRef = React.useRef()
    const currentUser = useSelector((state) => state.user)

    const [users, setUsers] = React.useState(null)
    const [labs, setLabs] = React.useState(null)
    const [templates, setTemplates] = React.useState(null)

    React.useEffect(() => {

        // Load templates asynchronously
        templatesPromise.then(loadedTemplates => {
            setTemplates(loadedTemplates)
        }).catch(error => {
            console.error('Failed to load templates:', error)
        })
    }, [])

    const breadcrumbs = [
        {
            key: 'home',
            label: 'Home',
            path: '/home',
            icon: HomeIcon
        },
        {
            key: 'admin',
            label: 'Admin',
            path: '/admin',
            icon: AdminIcon
        },
        {
            key: 'usermanagement',
            label: 'User Management',
            path: '/admin/usermanagement',
            icon: UsersIcon
        }
    ]

    const rowGetter = params => {
        return params.data
    }

    const valueGetter = params => {
        let colId = params.colDef.colId
        return params.data[colId]
    }

    const labGetter = params => {
        // DAS HIER IST BESSER ALS RENDERER UM GGF EIN POPUP FÜR DAS LAB VORZUSEHEN

        // besser noch als renderer

        /*
        let colId = params.colDef.colId
        let labId = params.data[colId]
        let lab = labs.get(labId)
        if(lab != null) {
            return lab.name
        } else {
            return null
        }
        */

        let colId = params.colDef.colId
        return JSON.stringify(params.data[colId])
    }

    const nameGetter = params => {
        let colId = params.colDef.colId
        let name = params.data['firstname'] != null ? params.data['firstname'] : ''
        name += ' '
        name += params.data['lastname'] != null ? params.data['lastname'] : ''
        if(name == null || name.trim().length <= 0) {
            return null
        } else {
            return name
        }
    }

    const columnDefs = [
        {
            colId: '_id',
            field: 'User ID',
            filter: 'agTextColumnFilter',
            resizable: true,
            valueGetter: valueGetter
        },
        {
            colId: 'name',
            field: 'Name',
            filter: 'agTextColumnFilter',
            resizable: true,
            valueGetter: nameGetter
        },
        {
            colId: 'username',
            field: 'Username',
            filter: 'agTextColumnFilter',
            resizable: true,
            valueGetter: valueGetter
        },
        {
            colId: 'email',
            field: 'Email',
            filter: 'agTextColumnFilter',
            resizable: true,
            valueGetter: valueGetter
        },
        {
            colId: 'lab',
            field: 'Einrichtung',
            filter: false,
            resizable: true,
            valueGetter: valueGetter,
            cellRenderer: LabRenderer
        },
        /*
        {
            colId: 'firstname',
            field: 'Firstname',
            filter: 'agTextColumnFilter',
            resizable: true,
            valueGetter: valueGetter
        },
        {
            colId: 'lastname',
            field: 'Lastname',
            filter: 'agTextColumnFilter',
            resizable: true,
            valueGetter: valueGetter
        },
        */
        {
            colId: 'isSuperuser',
            field: 'Admin',
            filter: false,
            resizable: true,
            valueGetter: valueGetter,
            cellRenderer: BooleanCellRenderer
        },
        {
            colId: 'state',
            field: 'Status',
            filter: false,
            resizable: true,
            valueGetter: valueGetter,
            cellRenderer: StateRenderer
        },
        {
            colId: 'state',
            field: 'Aktionen',
            filter: false,
            resizable: true,
            valueGetter: rowGetter,
            cellRenderer: ActionsCellRenderer
        }
    ]

    const defaultColDef = React.useMemo(() => ({
        sortable: true,
        floatingFilter: true,
        filterParams: {
            buttons: ['reset', 'apply'],
            closeOnApply: true
        }
    }))

    React.useEffect(() => {
        dispatch(setBreadcrumbs(breadcrumbs))
        dispatch(setToolbar(renderToolbar()))
        loadUserData()
        loadLabData()
    }, [])



    const loadUserData = () => {

        API.get('/api/user/list/').then(response => {
            setUsers(response.data)
        })

        setTimeout(() => { gridRef.current.api.sizeColumnsToFit() }, 200)
    }

    const loadLabData = () => {
        API.get("/api/labs/list/").then((response) => {
            const sortedLabs = response.data.sort((a, b) =>
            a.name.localeCompare(b.name),
            );
            setLabs(sortedLabs);
        });
    };


    const gridSizeChanged = () => {
        gridRef.current.api.sizeColumnsToFit()
    }

    const renderToolbar = () =>
        <>
            <Button
                size="small"
                startIcon={<AddUserIcon />}
                onClick={openAddUserDialog}
            >
                Add User
            </Button>

            {/* <VerticalSeparator color={'#888'} />
            <Button
                size="small"
                onClick={testEmail}
            >
                Test
            </Button> */}
        </>





    const [addUserDialogOpen, setAddUserDialogOpen] = React.useState(false)

    const openAddUserDialog = () => {
        setAddUserDialogOpen(true)
    }

    const closeAddUserDialog = () => {
        setAddUserDialogOpen(false)
    }

    const onAddUserSuccess = () => {
        setAddUserDialogOpen(false)
        loadUserData()
    }

    const renderAddUserDialog = () =>
        <Dialog
            scroll='body'
            // fullWidth={true}
            // fullWidth={fullWidth}
            // maxWidth={maxWidth}
            maxWidth={false}
            open={addUserDialogOpen}
            onClose={closeAddUserDialog}
        >
            <DialogTitle onClose={closeAddUserDialog}>
                <AddUserIcon style={{marginRight: '8px'}} />
                <span>Add User</span>
            </DialogTitle>
            <DialogContent>
                <AddUserForm
                    usernames={users !== null ? users.map(user => user.username) : []}
                    emails={users !== null ? users.map(user => user.email) : []}
                    labs={labs}
                    onSuccess={onAddUserSuccess}
                />
            </DialogContent>
        </Dialog>

    // Edit User Dialog
    const [editUserDialogOpen, setEditUserDialogOpen] = React.useState(false)
    const [editUser, setEditUser] = React.useState(null)

    const openEditUserDialog = (user) => {
        // Find the full user object from the users array
        const fullUser = users.find(u => u._id === user.id)
        if (fullUser) {
            setEditUser({
                id: fullUser._id,
                username: fullUser.username,
                email: fullUser.email,
                firstname: fullUser.firstname,
                lastname: fullUser.lastname,
                lab: fullUser.lab,
                role: fullUser.role,
                isSuperuser: fullUser.isSuperuser
            })
            setEditUserDialogOpen(true)
        }
    }

    const closeEditUserDialog = () => {
        setEditUserDialogOpen(false)
        setEditUser(null)
    }

    const onEditUserSuccess = () => {
        setEditUserDialogOpen(false)
        loadUserData()
    }

    const renderEditUserDialog = () =>
        <Dialog
            scroll='body'
            maxWidth={false}
            open={editUserDialogOpen}
            onClose={closeEditUserDialog}
        >
            <DialogTitle onClose={closeEditUserDialog}>
                <EditIcon style={{marginRight: '8px'}} />
                <span>Edit User</span>
            </DialogTitle>
            <DialogContent>
                <EditUserForm
                    user={editUser}
                    users={users || []}
                    labs={labs}
                    onSuccess={onEditUserSuccess}
                />
            </DialogContent>
        </Dialog>

    const [resetActivationDialogOpen, setResetActivationDialogOpen] = React.useState(false)
    const [resetActivationUser, setResetActivationUser] = React.useState({})

    const openResetActivationDialog = (resetActivationUser) => {
        setResetActivationUser(resetActivationUser)
        setResetActivationDialogOpen(true)
    }

    const closeResetActivationDialog = () => {
        setResetActivationDialogOpen(false)
        setResetActivationUser({})
    }

    const executeActivationReset = () => {
        API.post('/api/user/reset-activation-admin', {
            params: {...resetActivationUser, template: templates['activationAdmin']}
        }).then(() => {
            setTimeout(() => {
                closeResetActivationDialog()
                loadUserData()
            }
            , 500)
        })
    }

    const renderResetActivationDialog = () =>
        <Dialog
            scroll='body'
            // fullWidth={true}
            // fullWidth={fullWidth}
            // maxWidth={maxWidth}
            maxWidth={false}
            open={resetActivationDialogOpen}
            onClose={closeResetActivationDialog}
        >
            <DialogTitle onClose={closeResetActivationDialog}>
                <IconifyIcon icon="fluent:key-reset-24-filled" style={{marginRight: '8px', marginLeft: '-4px', fontSize: '28px'}}/>                
                <span>Activation Reset</span>
            </DialogTitle>
            <DialogContent className="reset-password-dialog-content">
                <div>
                    Do you want to reset the activation for user <b>{resetActivationUser.username}</b>?<br/>
                    The user will receive an email to repeat the activation of the account.
                </div>
                <Button
                    style={{ marginTop: '16px', backgroundColor: 'rgba(0,0,0,0.08)' }}
                    onClick={executeActivationReset}
                >
                    Confirm
                </Button>
            </DialogContent>
        </Dialog>







    








    const [resetPasswordDialogOpen, setResetPasswordDialogOpen] = React.useState(false)
    const [resetPasswordUser, setResetPasswordUser] = React.useState({})

    const openResetPasswordDialog = (resetPasswordUser) => {
        setResetPasswordUser(resetPasswordUser)
        setResetPasswordDialogOpen(true)
    }

    const closeResetPasswordDialog = () => {
        setResetPasswordDialogOpen(false)
        setResetPasswordUser({})
    }

    const executePasswordReset = () => {
        API.post('/api/user/reset-password-admin', {
            params: { ...resetPasswordUser, template: templates['resetPasswordAdmin'] }
        }).then(() => {
            setTimeout(() => {
                closeResetPasswordDialog()
                loadUserData()
            }
            , 500)
        })
    }

    const renderResetPasswordDialog = () =>
        <Dialog
            scroll='body'
            // fullWidth={true}
            // fullWidth={fullWidth}
            // maxWidth={maxWidth}
            maxWidth={false}
            open={resetPasswordDialogOpen}
            onClose={closeResetPasswordDialog}
        >
            <DialogTitle onClose={closeResetPasswordDialog}>
                <IconifyIcon icon="fluent:key-reset-24-filled" style={{marginRight: '8px', marginLeft: '-4px', fontSize: '28px'}}/>                
                <span>Password Reset</span>
            </DialogTitle>
            <DialogContent className="reset-password-dialog-content">
                <div>
                    Do you want to reset the password for user <b>{resetPasswordUser.username}</b>?<br/>
                    An email will be sent to the user to execute the password reset.
                </div>
                <Button
                    style={{ marginTop: '16px', backgroundColor: 'rgba(0,0,0,0.08)' }}
                    onClick={executePasswordReset}
                >
                    Confirm
                </Button>
            </DialogContent>
        </Dialog>










    const [deleteUserDialogOpen, setDeleteUserDialogOpen] = React.useState(false)
    const [deleteUser, setDeleteUser] = React.useState({})

    const openDeleteUserDialog = (deleteUser) => {
        setDeleteUser(deleteUser)
        setDeleteUserDialogOpen(true)
    }

    const closeDeleteUserDialog = () => {
        setDeleteUserDialogOpen(false)
        setDeleteUser({})
    }

    const executeUserDelete = () => {
        API.post('/api/user/delete-user-admin', {
            params: deleteUser
        }).then(() => {
            setTimeout(() => {
                closeDeleteUserDialog()
                loadUserData()
            }
            , 500)
        })
    }

    const renderDeleteUserDialog = () =>
        <Dialog
            scroll='body'
            // fullWidth={true}
            // fullWidth={fullWidth}
            // maxWidth={maxWidth}
            maxWidth={false}
            open={deleteUserDialogOpen}
            onClose={closeDeleteUserDialog}
        >
            <DialogTitle onClose={closeDeleteUserDialog}>
                <IconifyIcon icon="fluent:key-reset-24-filled" style={{marginRight: '8px', marginLeft: '-4px', fontSize: '28px'}}/>                
                <span>Delete User</span>
            </DialogTitle>
            <DialogContent className="reset-password-dialog-content">
                <div>
                    Do you want to delete the user <b>{deleteUser.username}</b>?<br/>
                </div>
                <Button
                    style={{ marginTop: '16px', backgroundColor: 'rgba(0,0,0,0.08)' }}
                    onClick={executeUserDelete}
                >
                    Confirm
                </Button>
            </DialogContent>
        </Dialog>

    




























    const renderView = () =>
        <div className="grid-container ag-theme-alpine ag-theme-alpine-modified">
            <AgGridReact
                className="users-grid"
                ref={gridRef}

                columnDefs={columnDefs}             // Column Defs for Columns
                defaultColDef={defaultColDef}       // Default Column Properties

                rowData={users}

                animateRows={true}
                
                // Filter options
                enableFilter={true}
                enableFloatingFilter={true}
                suppressMenuHide={true}

                onGridSizeChanged={gridSizeChanged}

                enableCellTextSelection={true}

                context={{
                    openEditUserDialog: openEditUserDialog,
                    openResetActivationDialog: openResetActivationDialog,
                    openResetPasswordDialog: openResetPasswordDialog,
                    openDeleteUserDialog: openDeleteUserDialog
                }}
            />
        </div>



    return (
        <>
            {
                renderView()
            }
            { renderAddUserDialog() }
            { renderEditUserDialog() }
            { renderResetActivationDialog() }
            { renderResetPasswordDialog() }
            { renderDeleteUserDialog() }
        </>
    )

}
